import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { TRACKING_CONFIG } from './tracking.config';
import { TrackingConfig } from './tracking.interface';

@Injectable()
export class FacebookPixelTracking {
  isEnabled = false;

  constructor(
    @Inject(TRACKING_CONFIG) private config: TrackingConfig,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    if (this.config.gaTrackingId && isPlatformBrowser(this.platformId)) {
      this.isEnabled = true;
    }
  }

  trackPageView(): void {
    if (!this.isEnabled) {
      return;
    }
    this.loadTrackingSnippet();
    window.fbq('track', 'PageView');
  }

  private loadTrackingSnippet(): void {
    if (window.fbq) {
      return;
    }
    window.fbq = function fbq() {
      if (window.fbq.callMethod) {
        // eslint-disable-next-line prefer-rest-params, prefer-spread
        window.fbq.callMethod.apply(window.fbq, arguments);
      } else {
        // eslint-disable-next-line prefer-rest-params
        window.fbq.queue.push(arguments);
      }
    };
    if (!window._fbq) {
      window._fbq = window.fbq;
    }
    window.fbq.push = window.fbq;
    window.fbq.loaded = true;
    window.fbq.version = '2.0';
    window.fbq.queue = [];

    const e = document.createElement('script');
    e.async = true;
    e.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = document.getElementsByTagName('script')[0];
    (s.parentNode as Node).insertBefore(e, s);

    window.fbq('init', this.config.facebookPixelId);
  }
}
